import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Card, Grid, Segment, Dropdown, Input, Button, Label} from 'semantic-ui-react';
import {noTimeZoneShortISODate, dateFormatPicker, originModificationDate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {parseDealers} from '../../../common/util/options';
import {parseAgencies} from '../common/utils';
import {downloadFile} from '../../../common/util/file';
import {Actions} from '../../../common/actions';
import Detail from './detail';
import './immobilized.scss';

class ImmobilizedOrders extends Component {
  constructor(props) {
    super(props);
    const {isUserFromTDE, dealerId, dealerAgency} = props;
    this.state = {
      'dealer': isUserFromTDE ? '' : dealerId,
      'agency': isUserFromTDE ? '' : dealerAgency,
      'initialDate': moment().startOf('month'),
      'finalDate': moment(),
      'orderCode': '',
      'isUserDealerM': true,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DealerOrdersImmobilized, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchDealers('importers');
    this.props.getAllAgencies();
  }

  componentDidUpdate() {
    const {fileUrl} = this.props;
    if (fileUrl) {
      downloadFile(fileUrl);
      this.props.clearImmobilizedDealeOrdersFile();
    }
  }

  componentWillUnmount() {
    this.props.clearImmobilizedDealeOrders();
  }

  handleParameterChange = (event, data) => {
    this.setState({[data.name]: data.value.toUpperCase()});
  }

  handleDealerChange = (event, data) => {
    this.setState({
      'agency': '',
      [data.name]: data.value,
    });
  }

  handleInitialDateChange = (value) => {
    const {finalDate} = this.state;

    this.setState({
      'initialDate': value,
      'finalDate': finalDate <= value ? value : finalDate,
    });
  }
  
  handleFinalDateChange = (value) => {
    this.setState({'finalDate': value});
  }

  handleClearClick = () => {
    const {isUserFromTDE, dealerId, dealerAgency, isUserDealerM} = this.props;
    this.props.clearImmobilizedDealeOrders();
    this.setState({
      'dealer': isUserFromTDE ? '' : dealerId,
      'agency': isUserFromTDE || isUserDealerM ? '' : dealerAgency,
      'initialDate': moment().startOf('month'),
      'finalDate': moment(),
      'orderCode': '',
    });
  }

  userError = () => {
    return this.props.isUserFromTDE ?
      'Es necesario especificar el concesionario, la agencia y el rango de fechas para la búsqueda' :
      'Es necesario especificar el rango de fechas para la búsqueda';
  }

  buildParameters = ({dealer, agency, initialDate, finalDate, orderCode}) => {
    return {
      dealer,
      agency,
      orderCode,
      'initialDate': moment(initialDate).format(noTimeZoneShortISODate),
      'finalDate': moment(finalDate).format(noTimeZoneShortISODate),
    };
  }

  handleAction = (e, {content}) => {
    const {dealer, agency, initialDate, finalDate} = this.state;
    const error = this.userError();

    if (!dealer || !agency || !initialDate || !finalDate) {
      this.props.addMessageBoxError(error);
      return;
    }

    const parameters = this.buildParameters(this.state);

    if (content === 'BUSCAR') {
      this.props.fetchImmobilizedDealeOrders(parameters);
    } else {
      this.props.downloadImmobilizedDealeOrders(parameters);
    }
  }

  renderDealerInfo() {
    const {isUserFromTDE, loading, agencies, dealers, orderDetail} = this.props;
    const {dealer, agency, isUserDealerM} = this.state;
    if (!isUserFromTDE && !isUserDealerM) {
      return null;
    }

    return (
      <Grid.Row textAlign='left' columns='3'>
        <Grid.Column>
          <label><strong>Concesionario</strong></label>
          <Dropdown fluid selection
            name='dealer'
            search
            value={dealer}
            options={parseDealers(dealers)}
            disabled={loading || !isUserFromTDE || !isUserDealerM}
            onChange={this.handleDealerChange}
          />
        </Grid.Column>
        <Grid.Column>
          <label><strong>Agencia</strong></label>
          <Dropdown fluid selection
            name='agency'
            search
            value={agency}
            options={parseAgencies(agencies, dealer) }
            disabled={loading || (!isUserFromTDE && !isUserDealerM)}
            onChange={this.handleParameterChange}
          />
        </Grid.Column>
        {(orderDetail.length && orderDetail[0]) ? (
          <Grid.Column>
            <label><strong>Fecha de proceso</strong></label>
            <Input
              fluid
              name='processDate'
              maxLength='8'
              value={moment(orderDetail[0].processDate).format(originModificationDate)}
              readOnly
            />
          </Grid.Column>) : null}
      </Grid.Row>
    );
  }

  render() {
    const {loading, downloading, orderDetail} = this.props;
    const {initialDate, finalDate, orderCode} = this.state;

    return (
      <div className='dealer-immobilized-orders'>
        <Card raised fluid>
          <Grid>
            <Grid.Row>
              <Grid.Column className='orders-title' width='9' textAlign='left'>
                <h2>Pedidos de Vehículos Inmovilizados</h2>
                <Label className='orders-total' color='red'>
                  Total ordenes
                  <Label.Detail>{orderDetail.length}</Label.Detail>
                </Label>
              </Grid.Column>
              <Grid.Column width='7' textAlign='right'>
                <Button secondary onClick={this.handleClearClick}>
                  LIMPIAR
                </Button>
                <Button
                  primary
                  content='BUSCAR'
                  disabled={loading || downloading}
                  onClick={this.handleAction}
                />
                <Button
                  primary
                  content='DESCARGAR'
                  disabled={loading || downloading}
                  onClick={this.handleAction}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Segment secondary>
                  <Grid>
                    <Grid.Row textAlign='left' columns='3'>
                      <Grid.Column>
                        <label>
                          <strong>Fecha inicial</strong>
                        </label>
                        <DatePicker
                          customInput={<Input fluid icon='calendar' />}
                          dateFormat={dateFormatPicker}
                          selected={moment(initialDate).toDate()}
                          onChange={this.handleInitialDateChange}
                          locale='es'
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <label>
                          <strong>Fecha final</strong>
                        </label>
                        <DatePicker
                          customInput={<Input fluid icon='calendar' />}
                          dateFormat={dateFormatPicker}
                          minDate={moment(initialDate).toDate()}
                          selected={moment(finalDate).toDate()}
                          onChange={this.handleFinalDateChange}
                          locale='es'
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <label>
                          <strong>Número de Pedido</strong>
                        </label>
                        <Input
                          fluid
                          name='orderCode'
                          maxLength='8'
                          value={orderCode}
                          onChange={this.handleParameterChange}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    {this.renderDealerInfo()}
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Detail />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {loading, loadingAgencies} = state.dealer;

  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
    'dealerAgency': state.session.dealerAgency,
    'permissions': state.session.permissions,
    'loading': loading || loadingAgencies || state.dealerOrdersImmobilized.loading,
    'dealers': state.dealer.list,
    'agencies': state.dealer.agencies,
    'downloading': state.dealerOrdersImmobilized.downloading,
    'orderDetail': state.dealerOrdersImmobilized.list,
    'fileUrl': state.dealerOrdersImmobilized.fileUrl,
  };
};

const {
  fetchDealers,
  getAllAgencies,
  downloadPossFile,
  addMessageBoxError,
  navigateTo,
  fetchImmobilizedDealeOrders,
  clearImmobilizedDealeOrders,
  downloadImmobilizedDealeOrders,
  clearImmobilizedDealeOrdersFile,
} = Actions;

export default connect(mapStateToProps, {
  fetchDealers,
  getAllAgencies,
  downloadPossFile,
  addMessageBoxError,
  navigateTo,
  fetchImmobilizedDealeOrders,
  clearImmobilizedDealeOrders,
  downloadImmobilizedDealeOrders,
  clearImmobilizedDealeOrdersFile,
})(ImmobilizedOrders);
